import { Box, VStack } from 'native-base';
import React from 'react';
import {
    observer,
    GIFTCARD_FLOWS,
    useSpringBigStore,
    useTheme
} from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import { Button } from '~/shared/Theme';

const NoCards = ({
    setIsSetNameModalOpen,
    setOnSubmitAction
}: {
    setIsSetNameModalOpen: (value: boolean) => void
    setOnSubmitAction: (value: GIFTCARD_FLOWS | undefined) => void
}) => {

    const { member, merchant } = useSpringBigStore();

    const {
        card_text,
        radius_md,
    } = useTheme();

    const onAddCashFunds = () => {

        if (!member?.first_name || !member?.last_name || !member.confirmed_identity) {
            setIsSetNameModalOpen(true);
            setOnSubmitAction(GIFTCARD_FLOWS.addGiftCard);
        }
        else {
            observer.emit('open-actionsheet', GIFTCARD_FLOWS.addGiftCard);
        }
    };

    return (
        <VStack justifyContent={'space-between'} space={4}>
            <Box
                borderStyle={'dashed'}
                w={'full'}
                h={'full'}
                style={{
                    aspectRatio: 16 / 7,
                }}
                borderWidth={2}
                borderColor={card_text?.slice(0, 7) + '80'}
                justifyContent={'center'}
                alignSelf={'center'}
                borderRadius={radius_md && radius_md / 2 || 0}
            >
                {/*<Caption*/}
                {/*    alignSelf={'center'}*/}
                {/*    fontSize={20}*/}
                {/*    text={'giftCard.addCash'}*/}
                {/*    color={card_text?.slice(0, 7) + '80'}*/}
                {/*/>*/}
            </Box>
            {/*{*/}
            {/*    merchant &&*/}
            {/*    !merchant.hide_gift_card_payments &&*/}
            {/*    !merchant.gift_cards_purchase_disabled &&*/}
            {/*    <Button*/}
            {/*        text={'giftCard.addCash'}*/}
            {/*        fontSize={22}*/}
            {/*        variant={'text'}*/}
            {/*        onPress={onAddCashFunds}*/}
            {/*    />*/}
            {/*}*/}
        </VStack>
    );
};

export default NoCards;
